import React from 'react';
import { Hourglass } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';
import { Organization } from '../../../../types/organization.types';

interface TwilioStatusBannerProps {
  organization: Organization | null;
}

export const TwilioStatusBanner: React.FC<TwilioStatusBannerProps> = ({ organization }) => {
  // Don't show if Stage 3 (AI Assistant with Twilio) hasn't been completed yet
  const stage3Completed = organization?.onboardingSetup?.stage3?.completed;
  if (!stage3Completed) return null;

  // If a phone number is configured, Twilio is set up — hide the banner
  if (organization?.phoneNumbers?.inbound || organization?.phoneNumbers?.outbound) return null;

  return (
    <OnboardingStatusBanner
      icon={Hourglass}
      title="Twilio setup in progress"
      variant="yellow"
      iconClassName="animate-spin"
      iconAnimation={{ animationDuration: '4s' }}
    >
      <p className="text-xs">
        Our team is currently working on setting up your Twilio. Please continue setting up other
        stages while we wait!
      </p>
    </OnboardingStatusBanner>
  );
};
